<template>
  <div class="form-group">
<!--    <select @change="getFileByIndex($event.target.value)" class="form-select">
-->
    <select @change="$emit('change',$event.target.value)" class="form-select">    
      <option v-if="selectedItem === undefined">Choose a {{ fileType }}</option>
      <option v-for="(f, index) in fileList" :key="index" :value="index" :selected="selectedItem===index">
        {{ (index+1) }}.&nbsp; {{ f.displayName }}
      </option>
    </select>
  </div>
</template>
<script>
import router from '@/router/index';
import { mapGetters, mapActions } from 'vuex';
import { INIT_NO_OP_NUM, CDA_FILE_TYPE, PDF_FILE_TYPE, REPORT_FILE_TYPE } from '@/config';
import { 
  CdaNavigation,
  CdasNavigation,
  PdfNavigation,
  PdfsNavigation,
  ReportNavigation,
  ReportsNavigation

} from '@/store/modules/fsm/messages';
import {getCdaIndexById, getReportIndexById} from "../../../data/getters";

export default {
  name: 'file-list',
  props: {
    selectedItem: {
      type: Number,
      required: false
    },
    fileList: {
      type: Array,
      required: true
    },
    fileType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      INIT_NO_OP_NUM, CDA_FILE_TYPE, PDF_FILE_TYPE, REPORT_FILE_TYPE,
    }
  },
  methods: {
    getReportIndexById,
    getCdaIndexById,
    ...mapActions('login/cda', [
      'requestCdaById', 'clearCda'
    ]),
    ...mapActions('login/pdf', ['clearPdf']),
    ...mapActions('login/report', ['clearReport']),

    getFileByIndex(index) {
        index = parseInt(index);
      if(index !== INIT_NO_OP_NUM) {
        this.getFile({index});
      }
    },
    getFile(params) {
        let contentRouteName = '';
        let topLevelNavigation = '';          // router doesn't push to the top level navigation if params exist, so need this
        if (this.fileType === this.CDA_FILE_TYPE) {
          contentRouteName = CdaNavigation;
          topLevelNavigation = CdasNavigation;
        } else if (this.fileType === this.PDF_FILE_TYPE) {
          contentRouteName = PdfsNavigation;
          topLevelNavigation = PdfsNavigation;
        } else if (this.fileType === this.REPORT_FILE_TYPE) {
          contentRouteName = ReportNavigation;
          topLevelNavigation = ReportsNavigation;
        } else {
          this.$swal({
            type: 'error',
            title: `Unable to retrieve file`,
            text: `Unable to retrieve file of type '${this.fileType}'. Please try again or choose another file.`
          })
        }

        // refresh: if index not null, redirect, otherwise bring up a clean page
        if (params.index !== undefined) {
          if (contentRouteName === PdfsNavigation) {
            this.$emit('changed',params.index);
            // router.push({ name: contentRouteName, params: {...params, rotation: this.rotationOfPdfSelected} });
          }
          else {
            if(params.index !== this.$route.params.index)
              router.push({ name: contentRouteName, params: {...params, fileType:this.fileType } });
          }
        }
        else {
          router.push({name: topLevelNavigation});
          //this.initializePage(topLevelNavigation);
        }
    },

    initializePage(contentRouteName) {
      switch (contentRouteName) {
        case TOP_NAVIGATION.CDA:
          this.clearCda();
          break;

        case TOP_NAVIGATION.PDF:
          this.clearPdf();
          break;

        case TOP_NAVIGATION.REPORT:
          this.clearReport();
          break;
      }
    }
  }
}
export const TOP_NAVIGATION = {CDA: '/cdas', PDF: '/pdfs', REPORT: '/reports'}
</script>

<style scoped lang="scss">
  select {
    font-size: 0.9em;
  }
</style>
